import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pb4tgncq54: FaireBrandEntity = {
  token: "b_pb4tgncq54",
  type: "brand",
  name: "CARINARA",
  avatarUrl:
    "https://cdn.faire.com/fastly/14a7ec084dad04c12fc849c850e6f23f2dc067e6491d2c7bb6082fedcb8e06ac.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/81d9336c05d12df8f08f613894e718e73f69b0b6c3c8047d2c2d0fb2ac9b5f41.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/14a7ec084dad04c12fc849c850e6f23f2dc067e6491d2c7bb6082fedcb8e06ac.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/81d9336c05d12df8f08f613894e718e73f69b0b6c3c8047d2c2d0fb2ac9b5f41.jpeg",
  location: "Omaha, NE, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Our mission is simple: Help People Choose Good Food Over Medication. \n\nEveryone deserves the freedom to enjoy their favorite meals—without reaching for the Tums.\n\nCARINARA is the first tomato-free pasta sauce made for the millions who suffer from heartburn or acid reflux. Crafted with roasted carrots, caramelized onions, and fresh herbs, it delivers the rich, comforting flavor of marinara—without the acidity. We believe fresh, whole ingredients make all the difference.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:47.664Z",
    importedBy: "entity-db-cli",
  },
};
